import { PrinterCheck, PrinterIcon, PrinterXIcon } from 'lucide-react'
import { useEffect, useState } from 'react'

import { Button } from '@/components/ui/button'
import { Printer } from '@/lib/printer/printer'
import { cn } from '@/lib/utils'

export type PrinterConnectorProps = {
  printer: Printer
  className?: string
}

/** Stav USB tiskárny účtenek: nepodporováno / připojit / připojeno. */
export function PrinterConnector({ printer, className }: PrinterConnectorProps) {
  const [ready, setReady] = useState<boolean>(false)

  useEffect(() => {
    if (!printer || !printer.isBrowserSupported() || ready) {
      return
    }

    if (printer.isReady()) {
      setReady(true)
      return
    }

    let cancelled = false

    const onReady = (p: Printer) => {
      if (!cancelled) setReady(p.ready)
    }
    printer.onReady.push(onReady)

    printer.init().then(() => {
      if (!cancelled && printer.isReady()) {
        setReady(true)
      }
    })

    return () => {
      cancelled = true
      const idx = printer.onReady.indexOf(onReady)
      if (idx !== -1) printer.onReady.splice(idx, 1)
    }
  }, [printer, ready])

  if (!printer.isBrowserSupported()) {
    return (
      <span
        className={cn('inline-flex h-11 items-center gap-2 px-2 text-sm text-muted-foreground', className)}
        title="USB tisk funguje v Chrome nebo Edge"
      >
        <PrinterXIcon className="size-4" aria-hidden />
        <span className="hidden lg:inline">Prohlížeč nepodporuje USB tisk</span>
      </span>
    )
  }

  if (ready) {
    return (
      <span className={cn('inline-flex h-11 items-center gap-2 rounded-md bg-success-bg px-3 text-sm font-medium text-success', className)}>
        <PrinterCheck className="size-4" aria-hidden />
        <span className="hidden lg:inline">Tiskárna připojena</span>
      </span>
    )
  }

  return (
    <Button variant="outline" className={cn('h-11 px-4', className)} onClick={() => printer.requestDevice()} title="Vybrat USB tiskárnu">
      <PrinterIcon />
      <span className="hidden lg:inline">Připojit tiskárnu</span>
    </Button>
  )
}
